import React from 'react';
var ThemeContext = React.createContext(null);

if (process.env.NODE_ENV !== 'production') {
  ThemeContext.displayName = 'ThemeContext';
}

export default ThemeContext;


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/styles/esm/useTheme/ThemeContext.js
// module id = 915
// module chunks = 2